export default "__VITE_ASSET__df69bf01__"